import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="space-y-8 text-swiss-black leading-relaxed">
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">1. Information We Collect</h2>
        <p className="font-medium">
          When you interact with Millrock Industries Private Limited (operating as SVNATE), we may collect personal information that you voluntarily provide to us when expressing an interest in obtaining information about us or our products and services, when participating in activities on the Website, or otherwise contacting us. The personal information that we collect depends on the context of your interactions with us and the Website, the choices you make, and the products and features you use. The personal information we collect can include the following: Names; Phone Numbers; Email Addresses; Contact Preferences; and Project Details.
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">2. How We Use Your Information</h2>
        <p className="font-medium mb-4">
          We use personal information collected via our Website for a variety of business purposes described below. We process your personal information for these purposes in reliance on our legitimate business interests, in order to enter into or perform a contract with you, with your consent, and/or for compliance with our legal obligations.
        </p>
        <ul className="list-disc pl-6 font-medium space-y-2 marker:text-swiss-red">
          <li>To facilitate account creation and logon process.</li>
          <li>To fulfill and manage your orders and projects.</li>
          <li>To deliver services to the user (e.g., app development, web development).</li>
          <li>To respond to user inquiries/offer support to users.</li>
        </ul>
      </div>
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">3. Will Your Information Be Shared With Anyone?</h2>
        <p className="font-medium">
          We only share information with your consent, to comply with laws, to provide you with services, to protect your rights, or to fulfill business obligations. We may process or share data based on the following legal basis: Consent, Legitimate Interests, Performance of a Contract, or Legal Obligations. We do not sell your personal information to third parties.
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">4. How Long Do We Keep Your Information?</h2>
        <p className="font-medium">
          We will only keep your personal information for as long as it is necessary for the purposes set out in this privacy policy, unless a longer retention period is required or permitted by law (such as tax, accounting or other legal requirements).
        </p>
      </div>
      <div>
        <h2 className="text-2xl font-black uppercase tracking-tight mb-4 text-swiss-red">5. Contact Us</h2>
        <p className="font-medium">
          If you have questions or comments about this policy, you may email us at support@svnate.com or by post to: Millrock Industries Private Limited, Pune, Maharashtra, India.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
